<template>
    <div v-click-outside="() => $emit('reset-search')">
        <div :id="autocompleteContainterId"></div>

        <div class="search-suggestions" ref="suggestions">
            <div :id="autocompletePanelId"></div>
            <div v-show="searchTerm" class="dropdown-menu autosuggest-menu__list autosuggest-outer-list suggestions-list">
                <div class="suggestions-list__item">
                    <ais-configure :hits-per-page.camel="3" :rule-contexts.camel="ruleContext" />
                    <h3 class="list__title">Top Equipment</h3>
                    <ul class="autosuggest-inner-list">
                        <ais-hits>
                            <template v-slot="{ items, sendEvent}">
                                <li v-for="item in items" :key="item.objectID" v-on:click="onClick(item, sendEvent, suggestionClickLabel)" class="autosuggest-list-item">
                                    <template v-if="item.name">
                                        <div class="sqItemImage">
                                            <img v-if="item.image" onload="this.parentNode.style.display = 'block'"
                                                 onerror="this.src='/ResourcePackages/Main/assets/static_assets/img_placeholder.png'" v-bind:src="item.image ?? ''" v-bind:alt="item.name" />
                                            <div v-else class="no-image">
                                                <img src="/ResourcePackages/Main/assets/static_assets/img_placeholder.png" class="camera_icon" alt="No image available" />
                                            </div>
                                        </div>
                                        <div class="sqItemContent">
                                            <ais-highlight attribute="name" :hit="item" />
                                        </div>
                                    </template>
                                </li>
                                <li v-if="items.length == 0" class="autosuggest-menu__item pad_item">No Results</li>
                            </template>
                        </ais-hits>
                    </ul>
                    <button class="suggestions-list__viewMore" v-on:click="hashQuery('#equipment')">
                        View all equipment results
                    </button>
                </div>
                <div class="suggestions-list__item">
                    <ais-index :index-name="partsIndexName">
                        <query-rule-custom-data-extended></query-rule-custom-data-extended>
                        <ais-configure :rule-contexts.camel="ruleContext"></ais-configure>
                        <h3 class="list__title">Top Parts</h3>
                        <ul class="autosuggest-inner-list">
                            <ais-hits>
                                <template v-slot="{ items, sendEvent}">
                                    <li v-for="item in items" :key="item.objectID" v-on:click="onClick(item, sendEvent, suggestionClickLabel)" class="autosuggest-list-item">
                                        <template v-if="item.name">
                                            <div class="sqItemImage">
                                                <img v-if="item.image" onload="this.parentNode.style.display = 'block'"
                                                     onerror="this.src='/ResourcePackages/Main/assets/static_assets/img_placeholder.png'" v-bind:src="item.image ?? ''" v-bind:alt="item.name" />
                                                <div v-else class="no-image">
                                                    <img src="/ResourcePackages/Main/assets/static_assets/img_placeholder.png" class="camera_icon" alt="No image available" />
                                                </div>
                                            </div>
                                            <div class="sqItemContent">
                                                <ais-highlight attribute="name" :hit="item" />
                                            </div>
                                        </template>
                                    </li>
                                    <li v-if="items.length == 0" class="autosuggest-menu__item pad_item">No Results</li>
                                </template>
                            </ais-hits>
                        </ul>
                        <button class="suggestions-list__viewMore" v-on:click="hashQuery('#parts')">
                            View all parts & supplies
                        </button>
                    </ais-index>
                </div>
                <div class="suggestions-list__item">
                    <ais-index :index-name="contentIndexName">
                        <query-rule-custom-data-extended></query-rule-custom-data-extended>
                        <ais-configure :rule-contexts.camel="ruleContext"></ais-configure>
                        <h3 class="list__title">Top Pages</h3>
                        <ul class="autosuggest-inner-list">
                            <ais-hits>
                                <template v-slot="{ items, sendEvent}">
                                    <li v-for="item in items" :key="item.objectID" v-on:click="onClick(item, sendEvent, suggestionClickLabel)" class="autosuggest-list-item">
                                        <template v-if="item.title">
                                            <div class="sqItemContent">
                                                <ais-highlight attribute="title" :hit="item" />
                                            </div>
                                        </template>
                                    </li>
                                    <li v-if="items.length == 0" class="autosuggest-menu__item pad_item">No Results</li>
                                </template>
                            </ais-hits>
                        </ul>
                        <button class="suggestions-list__viewMore" v-on:click="hashQuery('#pages')">
                            View all web pages
                        </button>
                    </ais-index>

                    <ais-index :index-name="resourcesIndexName">
                        <query-rule-custom-data-extended></query-rule-custom-data-extended>
                        <ais-configure :rule-contexts.camel="ruleContext"></ais-configure>
                        <h3 class="list__title">Top Resources</h3>
                        <ul class="autosuggest-inner-list">
                            <ais-hits>
                                <template v-slot="{ items, sendEvent}">
                                    <li v-for="item in items" :key="item.objectID" v-on:click="onClick(item, sendEvent, suggestionClickLabel)" class="autosuggest-list-item">
                                        <template v-if="item.title">
                                            <div class="sqItemContent">
                                                <ais-highlight attribute="title" :hit="item" />
                                            </div>
                                        </template>
                                    </li>
                                    <li v-if="items.length == 0" class="autosuggest-menu__item pad_item">No Results</li>
                                </template>
                            </ais-hits>
                        </ul>
                        <button class="suggestions-list__viewMore" v-on:click="hashQuery('#resources')">
                            View all resources
                        </button>
                    </ais-index>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { debounce } from "../../functions/function-utils";
    import { autocomplete} from '@algolia/autocomplete-js';
    import { createWidgetMixin } from 'vue-instantsearch/vue2/es';
    import { connectSearchBox } from 'instantsearch.js/es/connectors';

    import { AisHighlight, AisIndex, AisConfigure, AisHits } from 'vue-instantsearch';
    import QueryRuleCustomDataExtended from "../../components/search/QueryRuleCustomDataExtended";
    import algoliaAutocompleteMixin from "../../mixins/algolia-autocomplete-mixin"

    import { Constants } from "../../functions/constants";
    import { CookieUtils } from "../../functions/cookie-utils";
    import algoliasearch from 'algoliasearch/lite';
    import { createAutocomplete } from '@algolia/autocomplete-core';
    import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
    import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';

    export default {
        name:"AutocompleteInstance",
        mixins: [algoliaAutocompleteMixin, createWidgetMixin({ connector: connectSearchBox })],
        components: {
            AisHighlight,
            AisIndex,
            AisConfigure,
            AisHits,
            QueryRuleCustomDataExtended,
        },
        props: {
            indexName: {
                type: String,
                default: ''
            },
            searchPageUrl: {
                type: String,
                default: ''
            },
            containerId: {
                type: String,
                default: ''
            },
            searchClient: {
                type: Object,
                default: null
            },
            placeholderText: {
                type: String,
                default: ''
            },
            equipmentIndexName: {
                type: String,
                default: ''
            },
            partsIndexName: {
                type: String,
                default: ''
            },
            resourcesIndexName: {
                type: String,
                default: ''
            },
            contentIndexName: {
                type: String,
                default: ''
            },
        },
        data: function(){
            return {
                currentAutocomplete: null,
                currentPlugins: [],
                enableInsights: false,
                search_term: null,
                isOpen:false,
                firstInput: true
            }
        },
        computed: {
            autocompleteContainterId: function(){
                return 'autocomplete-' + this.containerId
            },
            autocompletePanelId: function () {
                return 'autocomplete-panel-' + this.containerId
            }
        },
        methods: {
            scrollToElement(element) {
                var elementPosition = element.getBoundingClientRect().top;
                var offsetPosition = elementPosition + window.pageYOffset - 150;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        watch: {
            'state.query': {
                handler: function (val) {
                    const header = document.querySelector('header');
                    const box = document.getElementById(this.autocompleteContainterId);
                    if (!box) { return; }

                    if (header && header.contains(box)) { 
                        const headerSearch = document.querySelector('.top_menu_search');
                        if (headerSearch) {
                            headerSearch.classList.toggle('has_text', val.length > 0)
                        }
                    } else if (this.firstInput && val.length > 0) {
                        this.firstInput = false;
                        this.scrollToElement(box)
                    }
                }
            }
        },
        async created() {

        },
        mounted() {
            if (!this.currentAutocomplete) {
                var that = this;
                const { instantSearchInstance } = this;
                const searchClient = this.searchClient;

                function setInstantSearchUiState({ query }) {
                    instantSearchInstance.setUiState((uiState) => ({
                        ...uiState,
                        [instantSearchInstance.indexName]: {
                            ...uiState[instantSearchInstance.indexName],
                            query,
                        },
                    }));
                }
                const debouncedSetInstantSearchUiState = debounce(setInstantSearchUiState, 250)

                const initialState =
                    instantSearchInstance.mainIndex.getHelper()?.state || {};

                const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
                    key: 'instantsearch',
                    limit: 3,
                    transformSource({ source }) {
                        return {
                            ...source,
                            getItemUrl({ item }) {
                                return that.getQueryUrl(item.label);
                            },
                            templates: {
                                ...source.templates,
                                header({ state, html }) {
                                    return html`<span class="aa-SourceHeaderTitle">Recent Searches</span><div class="aa-SourceHeaderLine" />`;
                                },
                                item(params) {
                                    const { item, html } = params;

                                    return html`<a class="aa-ItemLink" href="${that.getQueryUrl(item.label) }">
                                        ${source.templates.item(params).props.children}
                                      </a>`;
                                }
                            }
                        };
                    },
                });

                const equipmentQuerySuggestionsPlugin = createQuerySuggestionsPlugin({
                    searchClient,
                    indexName: `${this.equipmentIndexName}_query_suggestions`,
                    getSearchParams({ state }) {
                        return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: state.query ? 5 : 10 });
                    },
                    transformSource({ source }) {
                        return {
                            ...source,
                            sourceId: 'querySuggestionsPlugin',
                            getItemUrl({ item }) {
                                return that.getQueryUrl(item.query);
                            },
                            getItems(params) {
                                return source.getItems(params);
                            },
                            templates: {
                                ...source.templates,
                                header({ state, html }) {
                                    return html`<span class="aa-SourceHeaderTitle">Popular Searches</span><div class="aa-SourceHeaderLine" />`;
                                },
                                item(params) {
                                    const { item, html } = params;

                                    return html`<a class="aa-ItemLink" href="${that.getQueryUrl(item.query)}">
                                        ${source.templates.item(params).props.children}
                                      </a>`;
                                }
                            }
                        };
                    },
                });

                const partsQuerySuggestionsPlugin = createQuerySuggestionsPlugin({
                    searchClient,
                    indexName: `${this.partsIndexName}_query_suggestions`,
                    getSearchParams({ state }) {
                        return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: state.query ? 5 : 10 });
                    },
                    transformSource({ source }) {
                        return {
                            ...source,
                            sourceId: 'querySuggestionsPlugin',
                            getItemUrl({ item }) {
                                return that.getQueryUrl(item.query);
                            },
                            getItems(params) {
                                return source.getItems(params);
                            },
                            templates: {
                                ...source.templates,
                                header({ state, html }) {
                                    return html`<span class="aa-SourceHeaderTitle">Popular Searches</span><div class="aa-SourceHeaderLine" />`;
                                },
                                item(params) {
                                    const { item, html } = params;

                                    return html`<a class="aa-ItemLink" href="${that.getQueryUrl(item.query)}">
                                        ${source.templates.item(params).props.children}
                                      </a>`;
                                }
                            }
                        };
                    },
                });

                const resourcesQuerySuggestionsPlugin = createQuerySuggestionsPlugin({
                    searchClient,
                    indexName: `${this.resourcesIndexName}_query_suggestions`,
                    getSearchParams({ state }) {
                        return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: state.query ? 5 : 10 });
                    },
                    transformSource({ source }) {
                        return {
                            ...source,
                            sourceId: 'querySuggestionsPlugin',
                            getItemUrl({ item }) {
                                return that.getQueryUrl(item.query);
                            },
                            getItems(params) {
                                return source.getItems(params);
                            },
                            templates: {
                                ...source.templates,
                                header({ state, html }) {
                                    return html`<span class="aa-SourceHeaderTitle">Popular Searches</span><div class="aa-SourceHeaderLine" />`;
                                },
                                item(params) {
                                    const { item, html } = params;

                                    return html`<a class="aa-ItemLink" href="${that.getQueryUrl(item.query)}">
                                        ${source.templates.item(params).props.children}
                                      </a>`;
                                }
                            }
                        };
                    },
                });

                const contentQuerySuggestionsPlugin = createQuerySuggestionsPlugin({
                    searchClient,
                    indexName: `${this.contentIndexName}_query_suggestions`,
                    getSearchParams({ state }) {
                        return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: state.query ? 5 : 10 });
                    },
                    transformSource({ source }) {
                        return {
                            ...source,
                            sourceId: 'querySuggestionsPlugin',
                            getItemUrl({ item }) {
                                return that.getQueryUrl(item.query);
                            },
                            getItems(params) {
                                return source.getItems(params);
                            },
                            templates: {
                                ...source.templates,
                                header({ state, html }) {
                                    return html`<span class="aa-SourceHeaderTitle">Popular Searches</span><div class="aa-SourceHeaderLine" />`;
                                },
                                item(params) {
                                    const { item, html } = params;

                                    return html`<a class="aa-ItemLink" href="${that.getQueryUrl(item.query)}">
                                        ${source.templates.item(params).props.children}
                                      </a>`;
                                }
                            }
                        };
                    },
                });

                this.currentAutocomplete = autocomplete({
                    container: '#' + this.autocompleteContainterId,
                    placeholder: this.placeholderText,
                    panelContainer: '#' + this.autocompletePanelId,
                    openOnFocus: true,
                    debug: false,
                    detachedMediaQuery: 'none',
                    initialState: { query: initialState.query || '' },
                    onSubmit({ state }) {
                        that.doQuery(state.query);
                    },
                    onReset() {
                        debouncedSetInstantSearchUiState({ query: '' });
                    },
                    onStateChange({ prevState, state, setIsOpen }) {
                        if (prevState.query !== state.query) {
                            debouncedSetInstantSearchUiState({ query: state.query });
                            that.search_term = state.query;
                        }
                        else if (that.search_term && prevState.isOpen == true && state.isOpen == false) {
                            setIsOpen(true);
                        }

                        that.isOpen = state.isOpen;
                    },
                    insights: that.enableInsights,
                    plugins: [recentSearchesPlugin, equipmentQuerySuggestionsPlugin, partsQuerySuggestionsPlugin, resourcesQuerySuggestionsPlugin, contentQuerySuggestionsPlugin],
                });
            }
        },
        beforeDestroy() {
            this.currentAutocomplete?.destroy();
        },
        destroyed() {

        }
    };
</script>